import type { LocaleCode } from '@/data/types';

const LOCALE_KEY = 'locale';
const SUPPORTED: LocaleCode[] = ['pt-BR', 'en'];

export function isLocaleCode(value: string | null | undefined): value is LocaleCode {
  return value === 'pt-BR' || value === 'en';
}

export function detectBrowserLocale(): LocaleCode {
  const languages = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];

  const prefersEnglish = languages.some(
    (lang) => lang.toLowerCase().startsWith('en'),
  );

  return prefersEnglish ? 'en' : 'pt-BR';
}

export function getInitialLocale(): LocaleCode {
  try {
    const stored = localStorage.getItem(LOCALE_KEY);
    if (isLocaleCode(stored)) return stored;
  } catch {
    // private mode / blocked storage
  }
  return detectBrowserLocale();
}

export function persistLocale(locale: LocaleCode): void {
  try {
    localStorage.setItem(LOCALE_KEY, locale);
  } catch {
    // ignore
  }
}

export function htmlLangFor(locale: LocaleCode): string {
  return locale === 'en' ? 'en' : 'pt-BR';
}

export { LOCALE_KEY, SUPPORTED };
